// Design System — Table constants
export const TABLE_ALIGN = { LEFT: 'left', CENTER: 'center', RIGHT: 'right' };
export const TABLE_ALIGNS = Object.values(TABLE_ALIGN);

export const TABLE_SIZE = { SM: 'sm', MD: 'md' };
export const TABLE_SIZES = Object.values(TABLE_SIZE);
